import React, { useEffect, useState } from 'react';
import styles from './Solutions.module.css';
import { getSolutionsContent } from '../../services/contentService';
import { ReactComponent as ArrowRightLight } from '../../assets/icons/arrow_right_light.svg';
import { CustomButton, CustomCardInfo, CustomFooter, CustomImage, CustomLoader, CustomMoreSection, CustomScrollIndicator, CustomTextMarkdown, CustomTitle } from '../../components';
import { useTranslation } from 'react-i18next';

const Solutions = () => {

    const {t} = useTranslation();

    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [pageContent, setPageContent] = useState<any>(null);

    useEffect(() => {
        handleGetSolutionsContent();
    }, []);

    const handleGetSolutionsContent = async () => {
        try {
            setIsLoading(true);

            const content = await getSolutionsContent();
            setPageContent(content);

            const homeImg = new Image();
            homeImg.onload = () => setIsLoading(false);
            homeImg.src = `${process.env.REACT_APP_API_BASE_URL}${content.A_block_image.url}`;
        } catch (e) {
            console.error(e);
            throw e;
        }
    }

    return (
        <div className={ styles.container }>
            
            { !isLoading &&
                <>

                    {/* A block */}
                    <div className={styles.A_block}>
                        <div className={styles.A_block_container_title}>
                            <div className={styles.left_spacer}></div>

                            <div className={styles.A_block_center_title}>
                                <CustomTitle isSubtitle className={styles.A_block_subtitle}>{pageContent.A_block_subtitle}</CustomTitle>
                                <CustomTitle center>{pageContent.A_block_title}</CustomTitle>
                            </div>
                            
                            <div className={styles.A_block_scroll_ind_container}>
                                <CustomScrollIndicator />
                            </div>
                        </div>

                        <div className={styles.A_block_img_container}>
                            <CustomImage src={`${process.env.REACT_APP_API_BASE_URL}${pageContent.A_block_image?.url}`} alt="" />
                        </div>

                        <div className={styles.A_block_paragraph_container}>
                            <CustomTextMarkdown className={styles.A_block_A_paragraph}>{pageContent.A_block_A_paragraph}</CustomTextMarkdown>
                            <CustomTextMarkdown className={styles.A_block_B_paragraph}>{pageContent.A_block_B_paragraph}</CustomTextMarkdown>
                        </div>
                    </div>


                    {/* B block */}
                    <div className={styles.B_block}>
                        <div className={styles.B_block_card}>
                            <div>
                                <CustomImage src={`${process.env.REACT_APP_API_BASE_URL}${pageContent.B_block_left_card?.image.url}`} alt="" />
                            </div>

                            <div className={styles.B_block_card_content}>
                                <CustomCardInfo 
                                    iconSize='2.5rem'
                                    title={pageContent.B_block_left_card.title}
                                    content={pageContent.B_block_left_card.content}
                                    iconUrl={`${process.env.REACT_APP_API_BASE_URL}${pageContent.B_block_left_card?.icon.url}`}
                                />
                            </div>
                        </div>

                        <div className={styles.B_block_content}>
                            <CustomTitle isSubtitle className={styles.B_block_subtitle}>{pageContent.B_block_subtitle}</CustomTitle>
                            <CustomTitle className={styles.B_block_A_title}>{pageContent.B_block_A_title}</CustomTitle>
                            <CustomTextMarkdown components={{ p : 'h3' }} className={styles.B_block_B_title}>{pageContent.B_block_B_title}</CustomTextMarkdown>

                            <CustomTextMarkdown className={styles.B_block_paragraph}>{pageContent.B_block_paragraph}</CustomTextMarkdown>

                            <div className={styles.B_block_cards_container}>
                                { pageContent.B_block_cards.map((item: any, index: number) => {
                                    return (
                                        <CustomCardInfo
                                            key={index}
                                            title={item.title}
                                            content={item.content}
                                            iconUrl={`${process.env.REACT_APP_API_BASE_URL}${item.icon.url}`}
                                        />
                                    );
                                })}
                            </div>
                        </div>
                    </div>


                    {/* C block */}
                    <div className={styles.C_block}>
                        <CustomTitle isSubtitle className={styles.C_block_subtitle}>{pageContent.C_block_subtitle}</CustomTitle>
                        <CustomTitle center className={styles.C_block_A_title}>{pageContent.C_block_A_title}</CustomTitle>
                        <CustomTextMarkdown components={{ p : 'h3' }} className={styles.C_block_B_title}>{pageContent.C_block_B_title}</CustomTextMarkdown>
                        <CustomTextMarkdown className={styles.C_block_paragraph}>{pageContent.C_block_paragraph}</CustomTextMarkdown>
                    
                        <div className={styles.C_block_cards_container}>
                            { pageContent.C_block_cards.map((item: any, index: number) => {
                                return (
                                    <div key={index} className={styles.C_block_card}>
                                        <div className={styles.C_block_card_top}>
                                            <span className={styles.C_block_card_index}>0{index+1}.</span>
                                            <CustomTextMarkdown className={styles.C_block_card_title}>{item.title}</CustomTextMarkdown>
                                            <CustomImage src={`${process.env.REACT_APP_API_BASE_URL}${item.image?.url}`} alt="" />
                                            <CustomTextMarkdown className={styles.C_block_card_content}>{item.content}</CustomTextMarkdown>
                                        </div>

                                        <div className={styles.C_block_card_bottom}>
                                            <CustomCardInfo
                                                title={''}
                                                className={styles.C_block_subcard}
                                                content={item.subcard.content}
                                                iconUrl={`${process.env.REACT_APP_API_BASE_URL}${item.subcard.icon.url}`}
                                            />
                                        </div>
                                    </div>
                                );
                            })}
                        </div>

                        {/* D block */}
                        <div className={styles.D_block}>
                            <div className={styles.D_block_container}>
                                <div className={styles.D_block_content}>
                                    <CustomTextMarkdown className={styles.D_block_title}>{pageContent.D_block_title}</CustomTextMarkdown>
                                    <CustomTextMarkdown className={styles.D_block_paragraph}>{pageContent.D_block_paragraph}</CustomTextMarkdown>
                                    <CustomButton
                                        buttonType="outlined"
                                        color="#FFFFFF"
                                        endIcon={<ArrowRightLight />}
                                        onClick={() => console.log()}>
                                        {t('solutions.equip_myself')}
                                    </CustomButton>
                                </div>
                            </div>
                        </div>
                        
                    </div>


                    {/* E block */}
                    <div className={styles.E_block}>
                        <CustomTitle isSubtitle className={styles.E_block_subtitle}>{pageContent.E_block_subtitle}</CustomTitle>
                        
                        <div className={styles.E_block_content}>
                            <div className={styles.E_block_title_container}>
                                <CustomTitle>{pageContent.E_block_A_title}</CustomTitle>
                                <CustomTextMarkdown components={{ p : 'h3' }} className={styles.E_block_B_title}>{pageContent.E_block_B_title}</CustomTextMarkdown>
                            </div>

                            <div className={styles.E_block_paragraph_container}>
                                <CustomTextMarkdown>{pageContent.E_block_paragraph}</CustomTextMarkdown>
                            </div>
                        </div>

                        <div className={styles.E_block_cards_container}>
                            { pageContent.E_block_cards_sections.map((item: any, index: number) => {
                                return (
                                    <div className={styles.E_block_cards_sections} key={index}>
                                        <h5 className={styles.E_block_cards_sections_title}>{item.title}</h5>
                                        <div>
                                            { item.cards.map((itemCard: any, indexCard: number) => {
                                                return (
                                                    <CustomCardInfo
                                                        key={indexCard}
                                                        className={styles.E_block_subcards}
                                                        title=''
                                                        content={itemCard.content}
                                                        iconUrl={`${process.env.REACT_APP_API_BASE_URL}${itemCard.icon.url}`}
                                                    />
                                                );
                                            })}
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    </div>


                    {/* F block */}
                    <div className={styles.F_block}>
                        <div>
                            <CustomTitle isSubtitle className={styles.F_block_subtitle}>{pageContent.F_block_subtitle}</CustomTitle>
                            <CustomTitle>{pageContent.F_block_A_title}</CustomTitle>
                            <CustomTextMarkdown>{pageContent.F_block_B_title}</CustomTextMarkdown>
                            <div className={styles.F_block_img_container}>
                                <CustomImage src={`${process.env.REACT_APP_API_BASE_URL}${pageContent.F_block_image.url}`} alt="" />
                            </div>
                            <CustomTextMarkdown className={styles.F_block_paragraph}>{pageContent.F_block_paragraph}</CustomTextMarkdown>
                        </div>

                        <div className={styles.F_block_cards_container}>
                            { pageContent.F_block_A_cards.map((item: any, index: number) => {
                                return (
                                    <CustomCardInfo
                                        className={styles.F_block_cards}
                                        key={index}
                                        title={item.title}
                                        content={item.content}
                                        iconUrl={`${process.env.REACT_APP_API_BASE_URL}${item.icon.url}`}
                                    />
                                );
                            })}
                        </div>

                        <div className={styles.F_block_bottom_card}>
                            <CustomCardInfo
                                iconSize='2rem'
                                className={styles.F_block_bottom_card_content}
                                title={pageContent.F_block_B_card.title}
                                content={pageContent.F_block_B_card.content}
                                iconUrl={`${process.env.REACT_APP_API_BASE_URL}${pageContent.F_block_B_card.icon.url}`}
                            />
                        </div>
                    </div>


                    {/* G block */}
                    <div className={styles.G_block}>
                        <CustomTitle isSubtitle className={styles.G_block_subtitle}>{pageContent.G_block_subtitle}</CustomTitle>
                        <CustomTitle className={styles.G_block_title}>{pageContent.G_block_title}</CustomTitle>

                        <div className={styles.G_block_cards_container}>
                            { pageContent.G_block_cards.map((item: any, index: number) => {
                                return (
                                    <CustomCardInfo
                                        cardType='bigIconCard'
                                        className={styles.G_block_card}
                                        key={index}
                                        title={item.title}
                                        content={item.content}
                                        iconUrl={`${process.env.REACT_APP_API_BASE_URL}${item.icon.url}`}
                                    />
                                );
                            })}
                        </div>
                    </div>

                    <CustomMoreSection />
                    <CustomFooter />

                </>
            }

            { isLoading &&
                <div className={styles.container_loader}>
                    <CustomLoader loaderType="skeleton" isLoading={isLoading}/>
                </div>
            }

        </div>
    )
}

export default Solutions;